import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { ActivatedRoute, Router } from '@angular/router'
import { MessageService, LazyLoadEvent, SortEvent } from 'primeng/api'
import { BreadcrumbService } from '../../shared-components/breadcrumb.service'
import { DatePipe } from '@angular/common'
import {
  AppSettingService,
  AppointmentService,
    PatientService,
    AppPreferencesService,
    GlobalSettingsService
} from '../../../../api/services'
import {
  DataPageOfAppointment,
  Appointment,
  AppontmentDto,
  Provider,
  Resource,
    Patient,
    UiPreferences
} from '../../../../api/models'
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms'
import { NgxSpinnerService } from 'ngx-spinner'
import { Customsort } from '../../../directives/customsort'
import { SelectedPatientService } from '../../patient/patient-list/patient-service'
import { CareFinitySession } from '../../../services/CareFinitySession'

@Component({
  selector: 'app-appointments-list',
  templateUrl: './appointments-list.component.html',
  styleUrls: ['./appointments-list.component.css'],
})
export class AppointmentsListComponent implements OnInit {
    Item = 'Appointments'
  appointments: DataPageOfAppointment
  appointmentsPrint: DataPageOfAppointment

  selectedPatient: Appointment
  apptform: UntypedFormGroup
  Showrecords: boolean = false
  rows: number
  DateFormat: any
  lastName: string
  firstName: string
  dOB: Date
  mRN: string
  yearRangeForDatePicker: string
  isprovider: boolean = true
  providerList: Array<Provider>
  ResourceList: Array<Resource>
  Lastpageindex: number = 1
  private cols: { field: string; header: string }[]

  providerName: string = ''

  resourceName: string = ''
  appDateStringPrint: string = ''
  /*
    *
     Default variable ::

    */
  pageNumber: number = 1
  sortcolumn: string = ''
  sortorder: string = ''

  formSet: UntypedFormGroup

  stateOptions: any[] = [
    { label: 'By Provider', value: 'P' },
    { label: 'By Resource', value: 'R' },
  ]

  showAppointment: boolean = false
    pageSize: number = 0;

    isPNearExpiry?: boolean = false;
    pNearExpirMessage?: string = '';
    isViewedMessage?: boolean = false;
    ispExpireViewedCount: number = 0;
    setPrintFlag: boolean = false;
    preferences: UiPreferences = {};

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private apptservice: AppointmentService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private _spinnerService: NgxSpinnerService,
    private cstsort: Customsort,
    private patientService: PatientService,
    private selectedPatientService: SelectedPatientService,
    private appSetting: AppSettingService,
    private globalsettingService: GlobalSettingsService,

  ) {
      this.breadcrumbService.setItems([{ label: '' }]);

     
  }

    ngOnInit() {

       
        const pExpireViewedCount = Number(localStorage.getItem('PExpireViewedCount')) || 0;
        const isPNearExpiry = localStorage.getItem('IsPNearExpiry') === 'true';

        if (pExpireViewedCount === 0 && isPNearExpiry)
        {
            this.isViewedMessage = true;
            this.isPNearExpiry = true;
            this.pNearExpirMessage = localStorage.getItem('PNearExpirMessage') || '';
        }

       

       
    this.pageSize = CareFinitySession?.applicationSettings?.apiDataPageSize;


    this.cols = [
      { field: 'appointmentTime', header: 'Time' },
      { field: 'patientName', header: ' Patient Name' },
      { field: 'appointmentSubject', header: 'Subject' },
      { field: 'appointmentReason', header: 'Reason' },
      { field: 'appointmentStatus', header: 'Status' },
    ]

    this.yearRangeForDatePicker = environment.yearRangeForDatePicker
    this.apptform = this.fb.group({
      isResource: new UntypedFormControl('', []),
      apptDate: new UntypedFormControl(new Date(), []),
      provider: new UntypedFormControl('', []),
      resource: new UntypedFormControl('', []),
    })

        this.globalsettingService
            .globalSettingsGetGlobalSettings({})
            .subscribe((result) => {
                this.preferences = result;
                this.Item = this.preferences?.appointments || 'Appointments';
            })

    this.ddlBindResourceProvider()


   
        this.appSetting
            .appSettingGetPracticeSettings$Response().subscribe((res) => {
                this.showAppointment = res.body.enablePatientDemographicPrint;
                if (CareFinitySession?.user.roles.patientRecordsPrint == true && this.showAppointment == true)
                {
                    this.setPrintFlag = true;
                }
                else
                {
                    this.setPrintFlag = false;
                }
            });



        

       


    }



    getPreferences() {
       
    }
    

  /**    
     * This method bind  dropdown list of  Provider  and Resource.
     * And also calls get_patients_appointments_list
     
    */
  //ddlBindResourceProvider() {
  //  this.apptservice
  //    .appointmentGetallprovidersandresources({
  //      emrpracticeId: localStorage.getItem('EmrPracticeId'),
  //    })
  //    .subscribe(
  //      (Result) => {
  //        this.providerList = Result.providerList
  //        this.ResourceList = Result.resourceList

  //        this.apptform.controls.provider.setValue(
  //          {
  //            providerId: Result.providerId,
  //            providerName: Result.providerName,
  //          },
  //          { emitEvent: false },
  //        )
  //        this.apptform.controls.resource.setValue(
  //          {
  //            resourceId: Result.resourceId,
  //            resourceName: Result.resourceName,
  //          },
  //          { emitEvent: false },
  //        )

  //        this.apptform.controls.isResource.setValue(Result.isResource)

  //        this.setSelection(
  //          this.stateOptions.find((i) => i.value === Result.isResource),
  //        )
  //      },
  //      (err) => {
  //        this.messageService.add({
  //          severity: 'error',
  //          summary: 'Error',
  //          detail: err?.error,
  //          life: 3000,
  //        })
  //      },
  //    )
  //}


    ddlBindResourceProvider() {
        this.apptservice
            .appointmentGetallprovidersandresources({
                emrpracticeId: localStorage.getItem('EmrPracticeId'),
                providerId: localStorage.getItem('providerId'),
                apptType: localStorage.getItem('apptType'),
                resourceId: localStorage.getItem('resourceId'),

            })
            .subscribe(
                (Result) => {
                    this.providerList = Result.providerList
                    this.ResourceList = Result.resourceList

                    this.apptform.controls.provider.setValue(
                        {
                            providerId: Result.providerId,
                            providerName: Result.providerName,
                        },
                        { emitEvent: false },
                    )
                    this.apptform.controls.resource.setValue(
                        {
                            resourceId: Result.resourceId,
                            resourceName: Result.resourceName,
                        },
                        { emitEvent: false },
                    )

                    this.apptform.controls.isResource.setValue(Result.isResource)

                    this.setSelection(
                        this.stateOptions.find((i) => i.value === Result.isResource),
                    )

                    //  Set localStorage if values are null or empty after receiving response

                    if (!localStorage.getItem('providerId')) {
                        localStorage.setItem('providerId', Result.providerId);
                    }
                    if (!localStorage.getItem('apptType')) {
                        localStorage.setItem('apptType', Result.isResource);
                    }
                    if (!localStorage.getItem('resourceId')) {
                        localStorage.setItem('resourceId', Result.resourceId);
                    }
                },
                (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: err?.error,
                        life: 3000,
                    })
                },
            )
    }
  /**
   * This method fetch the list of patients appointments as  per given parameters
   *  Parameters Outer::[pageNumber :: Sort column ::  Sort order]
   *  Parameters Inner::[Provider Id :: Resource ::  AppointmentsDate :: Practice Id :: Page Number]
   *  ReturnType      ::[DataPageOfAppointment]
   */

  //get_patients_appointments_list(
  //  pageNumber: number,
  //  sortcolumn: string,
  //  sortorder: string,
  //): void {
  //  if (this.apptform.value.apptDate == null) {
  //    this.messageService.add({
  //      key: 'alertToast',
  //      severity: 'error',
  //      detail: 'Invalid appointment date, a valid date is required',
  //      summary: 'ERROR',
  //      life: 5000,
  //    })
  //    return
  //  }

  //  let providerId = ''
  //  if (this.isprovider) {
  //    providerId = this.apptform.value.provider.providerId
  //    this.providerName = this.providerList?.find(
  //      (prd) => prd.providerId === providerId,
  //    )?.providerName
  //  } else {
  //    providerId = this.apptform.value.resource.resourceId
  //    this.providerName = this.ResourceList.find(
  //      (prd) => prd.resourceId === providerId,
  //    )?.resourceName
  //  }
  //  if (!providerId) {
  //    return
  //  }
  //  this.apptservice
  //    .appointmentSearch({
  //      providerId: providerId,
  //      isResource: this.apptform.value.isResource,
  //      apptDate: this.getTransformedDate(),
  //      emrpracticeId: localStorage.getItem('EmrPracticeId'),
  //      pageNumber: pageNumber,
  //    })
  //    .subscribe(
  //      (Resp_Appointment_List) => {
  //        this.appointments = Resp_Appointment_List

  //        if (this.appointments.totalRecords > 0) {
  //          this.Showrecords = true
  //        } else {
  //          this.Showrecords = false
  //        }
  //        this.rows = this.appointments.pageSize
  //      },
  //      (err) => {
  //        this.messageService.add({
  //          severity: 'error',
  //          summary: 'Error',
  //          detail: err?.error,
  //          life: 3000,
  //        })
  //      },
  //    )
  //}

  //print_patients_appointments_list(
  //  pageNumber: number,
  //  sortcolumn: string,
  //  sortorder: string,
  //): void {
  //  // debugger
  //  if (this.apptform.value.apptDate == null) {
  //    this.messageService.add({
  //      key: 'alertToast',
  //      severity: 'error',
  //      detail: 'Invalid appointment date, a valid date is required',
  //      summary: 'ERROR',
  //      life: 5000,
  //    })
  //    return
  //  }

  //  let providerId = ''
  //  if (this.isprovider) {
  //    providerId = this.apptform.value.provider.providerId
  //  } else {
  //    providerId = this.apptform.value.resource.resourceId
  //  }
  //  if (!providerId) {
  //    return
  //  }
  //  this.appDateStringPrint = this.getTransformedDate()
  //    if (this.showAppointment) {
  //        this.apptservice
  //            .appointmentPrintSearch({
  //                providerId: providerId,
  //                isResource: this.apptform.value.isResource,
  //                apptDate: this.getTransformedDate(),
  //                emrpracticeId: localStorage.getItem('EmrPracticeId'),
  //                pageNumber: pageNumber,
  //            })
  //            .subscribe(
  //                (Resp_Appointment_List) => {
  //                    this.appointmentsPrint = Resp_Appointment_List
  //                },
  //                (err) => {
  //                    this.messageService.add({
  //                        severity: 'error',
  //                        summary: 'Error',
  //                        detail: err?.error,
  //                        life: 3000,
  //                    })
  //                },
  //            )
  //    }
   
  //}



    get_patients_appointments_list(
        pageNumber: number,
        sortcolumn: string,
        sortorder: string,
    ): void {
        if (this.apptform.value.apptDate == null) {
            this.messageService.add({
                key: 'alertToast',
                severity: 'error',
                detail: 'Invalid appointment date, a valid date is required',
                summary: 'ERROR',
                life: 5000,
            })
            return
        }


        //let providerId = localStorage.getItem('providerId') || (this.isprovider ? this.apptform.value.provider.providerId: this.apptform.value.resource.resourceId);

        //if (!providerId) {
        //    return;
        //}

        //this.providerName = this.isprovider
        //    ? this.providerList?.find((prd) => prd.providerId === providerId)?.providerName
        //    : this.ResourceList?.find((prd) => prd.resourceId === providerId)?.resourceName;

        let providerId = ''
        if (this.isprovider) {


            if (localStorage.getItem('providerId')) {
                providerId = localStorage.getItem('providerId');
            }
            else {
                providerId = this.apptform.value.provider.providerId
            }
            this.providerName = this.providerList?.find(
                (prd) => prd.providerId === providerId,
            )?.providerName
        }
        else {
            providerId = this.apptform.value.resource.resourceId
            if (localStorage.getItem('resourceId')) {
                providerId = localStorage.getItem('resourceId');
            }
            else {
                providerId = this.apptform.value.resource.resourceId;
            }
            this.providerName = this.ResourceList.find(
                (prd) => prd.resourceId === providerId,
            )?.resourceName
        }
        if (!providerId) {
            return
        }

        //let providerId = localStorage.getItem('providerId') ||
        //    (this.isprovider
        //        ? this.apptform.value.provider.providerId
        //        : this.apptform.value.resource.resourceId);
        //if (!providerId) {
        //    return
        //}
        this.apptservice
            .appointmentSearch({
                providerId: providerId,
                isResource: this.apptform.value.isResource,
                apptDate: this.getTransformedDate(),
                emrpracticeId: localStorage.getItem('EmrPracticeId'),
                pageNumber: pageNumber,
            })
            .subscribe(
                (Resp_Appointment_List) => {
                    this.appointments = Resp_Appointment_List

                    if (this.appointments.totalRecords > 0) {
                        this.Showrecords = true
                    } else {
                        this.Showrecords = false
                    }
                    this.rows = this.appointments.pageSize
                },
                (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: err?.error,
                        life: 3000,
                    })
                },
        );


        
    }

    print_patients_appointments_list(
        pageNumber: number,
        sortcolumn: string,
        sortorder: string,
    ): void {
        // debugger
        if (this.apptform.value.apptDate == null) {
            this.messageService.add({
                key: 'alertToast',
                severity: 'error',
                detail: 'Invalid appointment date, a valid date is required',
                summary: 'ERROR',
                life: 5000,
            })
            return
        }

        let providerId = ''
        if (this.isprovider) {


            if (localStorage.getItem('providerId')) {
                providerId = localStorage.getItem('providerId');
            }
            else {
                providerId = this.apptform.value.provider.providerId
            }
            this.providerName = this.providerList?.find(
                (prd) => prd.providerId === providerId,
            )?.providerName
        }
        else {
            providerId = this.apptform.value.resource.resourceId
            if (localStorage.getItem('resourceId')) {
                providerId = localStorage.getItem('resourceId');
            }
            else {
                providerId = this.apptform.value.resource.resourceId;
            }
            this.providerName = this.ResourceList.find(
                (prd) => prd.resourceId === providerId,
            )?.resourceName
        }
        if (!providerId) {
            return
        }        
        this.appDateStringPrint = this.getTransformedDate()
        if (this.showAppointment) {
            this.apptservice
                .appointmentPrintSearch({
                    providerId: providerId,
                    isResource: this.apptform.value.isResource,
                    apptDate: this.getTransformedDate(),
                    emrpracticeId: localStorage.getItem('EmrPracticeId'),
                    pageNumber: pageNumber,
                })
                .subscribe(
                    (Resp_Appointment_List) => {
                        this.appointmentsPrint = Resp_Appointment_List
                    },
                    (err) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: err?.error,
                            life: 3000,
                        })
                    },
                )
        }

    }


  /**
   *  This method set the AppointmentDate from calander control in html template
   *  Parameters Outer::[AppointmentDate]
   *  ReturnType::[appDateString]
   */
  OnSelectAppointmentDateChange(event: any) {
    // this.ddlBindResourceProvider();
    this.get_patients_appointments_list(
      this.pageNumber,
      this.sortcolumn,
      this.sortorder,
    )

    this.print_patients_appointments_list(
      this.pageNumber,
      this.sortcolumn,
      this.sortorder,
    )
  }

  setSelection(item: any) {
      const providerId = localStorage.getItem('providerId');
      const resourceId = localStorage.getItem('resourceId');

      if (!item?.value) {
          return
      }

      if (item?.value == 'P') {
          this.isprovider = true;
          localStorage.setItem('apptType', "P");


      } else {
          this.isprovider = false;
          localStorage.setItem('apptType', "R");


      }
    this.get_patients_appointments_list(
      this.pageNumber,
      this.sortcolumn,
      this.sortorder,
    )

    this.print_patients_appointments_list(
      this.pageNumber,
      this.sortcolumn,
      this.sortorder,
    )
  }
    setproviderId() {
        if (this.isprovider) {

            const selectedProvider = this.apptform.controls.provider.value;

            if (selectedProvider) {

                localStorage.setItem('providerId', selectedProvider.providerId);
                localStorage.setItem('providerName', selectedProvider.providerName);
                localStorage.setItem('apptType', "P");
                console.log('Provider stored:', selectedProvider);
            }
        }
        else {
            const selectedResource = this.apptform.controls.resource.value;

            if (selectedResource) {

                localStorage.setItem('resourceId', selectedResource.resourceId);
                localStorage.setItem('providerName', selectedResource.resourceName);
                localStorage.setItem('apptType', "R");
                console.log('Resource stored:', selectedResource);
            }

        }
    this.get_patients_appointments_list(
      this.pageNumber,
      this.sortcolumn,
      this.sortorder,
    )
    this.print_patients_appointments_list(
      this.pageNumber,
      this.sortcolumn,
      this.sortorder,
    )
  }

  refresh() {
    this.get_patients_appointments_list(
      this.pageNumber,
      this.sortcolumn,
      this.sortorder,
    )
    this.print_patients_appointments_list(
      this.pageNumber,
      this.sortcolumn,
      this.sortorder,
    )
  }

  nextPage($event: LazyLoadEvent) {
    let pageIndex = $event.first / $event.rows + 1 // Index of the new page if event.page not defined.
    let sort_order = 'Asc'
    if ($event.sortOrder == -1) {
      sort_order = 'Desc'
    }

    if (this.Lastpageindex != pageIndex) {
      this.get_patients_appointments_list(
        pageIndex,
        $event.sortField,
        this.sortorder,
      )
    } else {
      this.CustomSort($event.sortField, sort_order)
    }
    if (this.Lastpageindex != pageIndex) {
      this.Lastpageindex = pageIndex
    }
  }
  CustomSort(sortfield, order) {
    // console.log(sortfield);
    //console.log(order);

    switch (sortfield) {
      case 'appointmentTime':
        if (order == 'Asc') {
          this.appointments.data.sort((a, b) => {
            let Patient1 = a.appointmentTime
            let Patient2 = b.appointmentTime
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          this.appointments.data.sort((a, b) => {
            let Patient1 = a.appointmentTime
            let Patient2 = b.appointmentTime
            return Patient1 > Patient2 ? -1 : 1
          })
        }

        break
      case 'patientName':
        if (order == 'Asc') {
          this.appointments.data.sort((a, b) => {
            let Patient1 = a.patientName
            let Patient2 = b.patientName
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          this.appointments.data.sort((a, b) => {
            let Patient1 = a.patientName
            let Patient2 = b.patientName
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'appointmentSubject':
        if (order == 'Asc') {
          this.appointments.data.sort((a, b) => {
            let Patient1 = a.appointmentSubject
            let Patient2 = b.appointmentSubject
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          this.appointments.data.sort((a, b) => {
            let Patient1 = a.appointmentSubject
            let Patient2 = b.appointmentSubject
            return Patient1 > Patient2 ? -1 : 1
          })
        }

        break
      case 'appointmentReason':
        if (order == 'Asc') {
          this.appointments.data.sort((a, b) => {
            let Patient1 = a.appointmentReason
            let Patient2 = b.appointmentReason
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          this.appointments.data.sort((a, b) => {
            let Patient1 = a.appointmentReason
            let Patient2 = b.appointmentReason
            return Patient1 > Patient2 ? -1 : 1
          })
        }

        break
      case 'appointmentStatus':
        if (order == 'Asc') {
          this.appointments.data.sort((a, b) => {
            let Patient1 = a.appointmentStatus
            let Patient2 = b.appointmentStatus
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          this.appointments.data.sort((a, b) => {
            let Patient1 = a.appointmentStatus
            let Patient2 = b.appointmentStatus
            return Patient1 > Patient2 ? -1 : 1
          })
        }

        break
    }
  }

  basedOnModeofTrack(obj: any) {
    //  alert(obj.value);
    console.log('FFFFFFFFFFFF')
    console.log(obj)
  }

  customSort(event: SortEvent, num: number) {
    //  alert(event);
    this.appointments.data = this.cstsort.generalcustomSort(
      event,
      this.appointments.data,
    )
  }

    printAppointments() {

        this.apptservice
            .appointmentPrint({
                providerId: "1",
                isResource: this.apptform.value.isResource,
                apptDate: this.getTransformedDate(),
                emrpracticeId: localStorage.getItem('EmrPracticeId'),               
            }).subscribe(
                () => {
                   
                }
                
            )



    var PrintAppointments = document.getElementById(
      'PrintAppointments_List',
    ) as HTMLElement
    const printWindow = window.open('', '_blank')
    //const printWindow = window.open('', 'printdiv');
    if (printWindow) {
      const divContent = PrintAppointments.innerHTML
      printWindow.document.open()
      printWindow.document.write(
        '<html><head><title>Print::Appointments List</title>',
      )
      // Adding CSS styling for alternate rows
      printWindow.document.write('<style type="text/css">')
      printWindow.document.write(
        '    #appointment_print_table_tbody tbody tr:nth-child(odd) {',
      )
      printWindow.document.write('        background-color: #f2f2f2;')
      printWindow.document.write('    }')
      printWindow.document.write(
        '    #appointment_print_table_tbody tbody tr:nth-child(even) {',
      )
      printWindow.document.write('        background-color: #e6e6e6;')
      printWindow.document.write('    }')
      printWindow.document.write('</style>')
      printWindow.document.write('</head><body>')
      printWindow.document.write(divContent)
      printWindow.document.write('</body><html>')
      printWindow.document.close()
      printWindow.focus()
      printWindow.print()
      printWindow.close()
    } else {
      console.error('Failed to open print window.')
    }
  }

  getPatientDetails(patient: Patient) {
    sessionStorage.setItem('ptName', patient['patientName'])
   sessionStorage.setItem('ptId', patient['patientId'])

    this.patientService
      .patientGetPatientDetails({
        personId: patient.patientId,
        practiceId: localStorage.getItem('EmrPracticeId'),
      })
      .subscribe((p) => {
        //localStorage.setItem("ptName", patient['patientName']);
        //localStorage.setItem("ptId", patient['patientId']);

        //localStorage.setItem("ptName", p['fullName']);
        //localStorage.setItem("ptId", p['patientId']);

        this.selectedPatientService.changePatient({
          ...patient,
          isPatientArchived: p.isPatientArchived,
        })

        this.router.navigate(['Patient/dashboard'])
      })
  }



    goToChangePassword(): void {
        // Increment the password expiry viewed count
        let PExpireViewedCount = Number(localStorage.getItem('PExpireViewedCount')) || 0;
        PExpireViewedCount++;
        localStorage.setItem('PExpireViewedCount', PExpireViewedCount.toString());
        this.isViewedMessage = false;
        // Navigate to the change password page
        this.router.navigate(['settings/change-password']);
    }


    ackOK(): void {
        // Retrieve and increment the password expiry viewed count
        const PExpireViewedCount = Number(localStorage.getItem('PExpireViewedCount')) || 0;
        const updatedCount = PExpireViewedCount + 1;

        // Update the value in localStorage
        localStorage.setItem('PExpireViewedCount', updatedCount.toString());

        // Set the viewed message flag
        this.isViewedMessage = false;
    }


  getTransformedDate() {
    return this.datePipe.transform(
      this.apptform.value.apptDate,
      environment.dateformat,
    )
    }

    onDialogClose() {       
        const pExpireViewedCount = Number(localStorage.getItem('PExpireViewedCount')) || 0;
        const updatedCount = pExpireViewedCount + 1;

        // Update the value in localStorage
        localStorage.setItem('PExpireViewedCount', updatedCount.toString());

        // Set the viewed message flag
        this.isViewedMessage = false;
    }
}
